import { portalWebUrl } from '../../../../features/url/baseUrl';
import { Article } from '../../../../types/Article';
import { News } from '../../../../types/News';
import { ArticleCard } from '../../../Article/ArticleCard';
import { InnerMargin } from '../../../Layout/InnerLayout/InnerMargin';
import {
  BlockNavigationMyPageIndex,
  type BlockNavigationMyPageIndexProps,
} from '../../../Navigation/Block/BlockNavigationMypageIndex';
import { NewsCard } from '../../../News/NewsCard';
import { Title } from '../../../Title';

import type { LoggedInUser } from '../../../../types/LoggedInUser';
import type { AppEnv } from '@/packages/nurse-senka-frontend-sdk';
import type { FC } from 'react';

export type MyPageContentsProps = BlockNavigationMyPageIndexProps & {
  appEnv: AppEnv;
  loggedInUser: LoggedInUser;
  news?: News[];
  bookmarkedArticles?: Article[];
  articleViewHistory?: Article[];
};

// eslint-disable-next-line max-lines-per-function
export const MyPageContents: FC<MyPageContentsProps> = ({
  appEnv,
  news,
  blockNavigationMyPageIndexLinks,
  bookmarkedArticles,
  articleViewHistory,
}) => (
  <>
    <InnerMargin align="default">
      <BlockNavigationMyPageIndex
        appEnv={appEnv}
        blockNavigationMyPageIndexLinks={blockNavigationMyPageIndexLinks}
      />
    </InnerMargin>

    {news ? (
      <InnerMargin align="default">
        <Title
          type="h2"
          title="お知らせ"
          linkText="お知らせ一覧"
          link={`${portalWebUrl(appEnv)}/informations`}
        />
        <NewsCard newsList={news} />
      </InnerMargin>
    ) : (
      ''
    )}

    {bookmarkedArticles ? (
      <InnerMargin align="default">
        <Title
          type="h2"
          title="あとでみる"
          linkText="あとでみる一覧"
          // TODO あとでみる機能は https://github.com/nurse-senka/nurse-senka/issues/570 で作成されるのでそれまでは非表示にする
          link="https://media.nurse-senka.jp"
        />
        <ArticleCard
          type="vertical"
          rank={false}
          appEnv={appEnv}
          articles={bookmarkedArticles}
        />
      </InnerMargin>
    ) : (
      ''
    )}

    {articleViewHistory ? (
      <InnerMargin align="default">
        <Title
          type="h2"
          title="閲覧履歴"
          linkText="閲覧履歴一覧"
          // TODO 閲覧履歴機能は https://github.com/nurse-senka/nurse-senka/issues/570 で作成されるのでそれまでは非表示にする
          link="https://media.nurse-senka.jp"
        />
        <ArticleCard
          type="vertical"
          rank={false}
          appEnv={appEnv}
          articles={articleViewHistory}
        />
      </InnerMargin>
    ) : (
      ''
    )}
  </>
);
